
import { Component, Vue, Watch } from "vue-property-decorator";
import { PackageService, WechatService, OrganizationService } from "src/services";
import { Toast, Dialog } from "vant";
import { tools } from "src/utils";
import dayjs from "dayjs";
import goodsCategory from "src/components/goods-category"
import udialog from "src/components/dialog";
import { IgnorePlugin } from "webpack";


Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate" // for vue-router 2.2+
]);

@Component({
    components:{
        goodsCategory,
        udialog
    }
})
export default class PackageDetail extends Vue
{
    /**
     * 是否显示弹框
     * @private
     * @returns boolean
     */
     private isShowDialog: boolean = false;

    /**
     * 弹框名称
     * @private
     * @returns boolean
     */
     private dialogName: string = "";

     /**
     * 弹框内容
     * @private
     * @returns boolean
     */
     private dialogContent: string = "";

    /**
     * 显示详情
     * @private
     * @returns boolean
     */ 
    private showDetail: boolean = false;

    /**
     * 固定套餐价格
     * @private
     * @returns number
     */ 
    private packageBasePrice: number = 0;

    /**
     * 显示详情
     * @private
     * @returns boolean
     */ 
    private ball: any = {
        el: null,
        show: false,
    }

    /**
     * 所有数据集合
     * @private
     * @returns Array<string>
     */ 
    private dataList: Array<string> = [];

    /**
     * 查看更多name+id集合
     * @private
     * @returns Array<string>
     */ 
    private titleList: Array<string> = [];

    /**
     * 标签数组
     * @private
     * @returns  Array<any>
     */ 
    private tagGroups: Array<any> = [];
        
    /**
     * 显示加项弹框
     * @private
     * @returns boolean
     */ 
    private showDialog: boolean = false;

    /**
     * 自选额度比例
     * @private
     * @returns any
     */
    private showTipModel: boolean = true;

    /**
     * 变量集合
     * @protected
     * @returns any
     */
     protected state: any = {
        listHeight: [],
        categoryHeight: [],
        currentIndex: 0
    };

    /**
     * 显示日期
     * @private
     * @returns boolean
     */
    private showDate: boolean = false;

    /**
     * 主题配置
     * @private
     * @returns any
     */
    private get properties(): any
    {
        return this.$store.state.properties || {};
    }

    /**
     * 确认日期
     * @private
     * @returns void
     */
    private onDateSelect(date: any, period: any): void
    {
        if(date)
        {
            this.selectDate = dayjs(date).format("YYYY-MM-DD");
            this.physicalTimePeriod = period;
        }

        // this.showDate = false;
        // this.onNext();
    }

    /**
     * 日期取消选择
     * @private
     * @returns string
     */
    private onDateCancel(): void
    {
        this.selectDate = this.selectedDate || '';
        this.physicalTimePeriod = this.physicaledTimePeriod || '';
    }

    // 获取高度
    protected listHeight() {
        // 内容高度
        let items = document.getElementsByClassName('goods-category-item');
        let height = 0;

        for (let i = 0; i < items.length; i++) {
            this.state.listHeight.push(height);
            let offsetHeight = (items[i] as any).offsetHeight;
            height+=offsetHeight;
        }

        // 分类高度
        let categorys = document.getElementsByClassName('goods-category-type-li');

        let categoryHeight = 0;
        
        for (let i = 0; i < categorys.length; i++) {
            this.state.categoryHeight.push(categoryHeight);
            let offsetHeight = (categorys[i] as any).offsetHeight;
            categoryHeight+=offsetHeight;
        }
       

    }

    // 点击分类
    protected onCategoryClick(index)
    {
        this.state.currentIndex = index;
        (document.getElementById('goods-category-list') as any).scrollTop = this.state.listHeight[index]
    }

    // 滚动数据
    protected onscroll() {
        let scrolltop = document.getElementById('goods-category-list').scrollTop;
        for (let i = 0; i < this.state.listHeight.length; i++) {
            if ((scrolltop >  this.state.listHeight[i]) && (scrolltop <  this.state.listHeight[i + 1])) {
                this.state.currentIndex= i;
                (document.getElementById('goods-category-type') as any).scrollTop = this.state.categoryHeight[i-1 || 0]
            }
        }
    }

    /**
     * 加项套餐项目
     * @private
     * @returns Array<any>
     */
    private optionalItemTypesOut: Array<any> = [];

    /**
     * 搜索条件
     * @private
     * @returns any
     */
    private filter: any =
    {
        packageId: null, // 套餐id
        hospitalId: null, // 医院Id
        cityName: null, // 城市名称
        longitude: null, // 经度
        latitude: null // 纬度
    };

    /**
     * 资产抵扣信息
     * @private
     * @returns any
     */
    private assetConsumeInfo: any =
    {
        couponId: 0, // 钱包id
        isUsedAsset: false,     // 是否使用了资产
        needPayAmount: 0,       // 需要支付金额
        couponUsingAmount: 0,       // 报销
        walletUsingAmount: 0,    // 额度
        couponRate: 0    // 报销比例
    };

    /**
     * 选中的标签id集合
     * @private
     * @returns any
     */
    private selectTagIds: any = [];

    /**
     * 选中的健康产品和加项集合
     * @private
     * @returns any
     */
    private selectIds: any = [];

    /**
     * 选中的加项集合
     * @private
     * @returns any
     */
    private optionalItemIds: any = [];

    /**
     * 选中的健康产品集合
     * @private
     * @returns any
     */
    private healthProductIds: any = [];

    /**
     * 医院/机构id
     * @private
     * @returns string
     */
    private get hospitalId(): string
    {
        return this.$route.query && (this.$route.query.hospitalId as string) || "";
    }

    /**
     * 选中自选金额比例
     * @private
     * @returns number
     */
    private get limitRatio(): number
    {
        if(this.assetConsumeInfo.couponMaxAmount > 0)
        {
            // 自选加权益 除以报销比例
            return this.optionalPrice/this.assetConsumeInfo.couponMaxAmount * 100;
        }
        
        return  0;
    }


    /**
     * 需要支付价格
     * @private
     * @returns number
     */
    private get payPrice(): string | number
    {
        return +this.packageBasePrice + this.optionalPrice;
    }

    /**
     * 自选金额
     * @private
     * @returns strig
     */
    private get optionalPrice(): number
    {
        // 自选加权益
        let selectItemPrice = [];
      
        this.dataList.forEach((item: any) => {

            item.items.forEach(data =>
            {
                if(this.selectIds.indexOf(data.itemId) > -1)
                {
                    selectItemPrice.push(data.itemPrice);
                }

            });
        });
        
        // 计算总金额
        let sum = selectItemPrice.reduce((prve: number,curr: number) =>
        {
            return prve + curr;
        }, 0);

        return (sum).toFixed(2) || 0;
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
     private get selectUserId(): any
    {
        let selectUserStorage = localStorage.getItem("selectUser");
        
        if(selectUserStorage)
        {
            return JSON.parse(selectUserStorage).employerMemberId || this.userInfo.userId;
        }

        return this.userInfo.userId;
    }

    /**
     * 套餐id
     * @private
     * @returns string
     */
    private get packageId(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 产品id
     * @private
     * @returns string
     */
     private get productId(): string
    {
        return this.$route.query && (this.$route.query.productId as string) || "";
    }

    /**
     * 选中日期
     * @private
     * @returns string
     */
    private get selectedDate(): string
    {
        return this.$route.query && (this.$route.query.date as string) || "";
    }

    /**
     * 选中日期
     * @private
     * @returns string
     */
     private get defaultDate(): any
    {
        return dayjs(this.selectedDate).toDate();
    }

    /**
     * 选中日期
     * @private
     * @returns any
     */ 
     private selectDate: any = "";

    private packageInformation : any = {
        packageName:"",     //套餐名称
        packageMarketPrice:null  // 套餐划线价
    }

    /**
     * 选中日期时间段
     * @private
     * @returns string
     */
    private get physicaledTimePeriod(): string
    {
        return this.$route.query && (this.$route.query.physicalTimePeriod as string) || "";
    }

    /**
     * 选中日期时间段
     * @private
     * @returns any
     */ 
     private physicalTimePeriod: any = "";

    /**
     * 当前位置
     * @private
     * @returns any
     */
    private get location(): any
    {
        return this.$store.getters.location || {};
    }

    /**
     * 获取用户信息
     * @private
     * @returns any
     */
    private get userInfo(): any
    {
        let userInfoStorge = localStorage.getItem("userInfo");

        if(userInfoStorge)
        {
            return JSON.parse(userInfoStorge)
        }

        return {};
    }

    /**
     * 显示加项详情
     * @private
     * @returns void
     */
    private onShowDetail(): void
    {
        // if(this.selectIds.length >0)
        // {
            if(this.showDetail)
            {
                this.showDetail = false;
            }
            else
            {
                this.showDetail = true;
            }
            
        // }
        
    }

    /**
     * 动画前
     * @private
     * @returns void
     */
    private beforeEnter(el) {
        
        // 购物车距离右边位置
        let elRight = this.getStyle(el, 'right') //购物车 right
        let elLeft = this.getStyle(el, 'left') //购物车 right
        // 购物车距离上边位置
        let elTop = this.getStyle(el, 'top') //购物车 top
        let elBottom = this.getStyle(el, 'bottom') //购物车 top

        let ele = this.ball.el //要添加购物车的商品
        let ract = ele.getBoundingClientRect() //商品的位置
 
        let x = ract.left - parseFloat(elLeft) // 计算小球移动的X轴的距离
        let y = window.innerHeight - ract.top - parseFloat(elBottom); // 计算小球移动的y轴的距离
        el.style.display = ''
        el.style.transform = `translateY(-${y}px) translateX(${x}px)` //重置小球的x轴位置
    }

    /**
     * 动画中
     * @private
     * @returns void
     */
    private enter(el, done) {
        let hh = el.offsetHeight //激发重绘

        el.style.transform = `translate(0, 0)`;

        el.addEventListener('transitionend', done)
    }
    
    /**
     * 动画后
     * @private
     * @returns void
     */
    private afterEnter(el) {
        this.ball.show = false
        el.style.display = 'none'
    }

    /**
     * 添加购物车
     * @private
     * @returns void
     */
    private addToCart(event) {
        this.ball.el = event.target
        this.ball.show = true
    }

    /**
     * 获取样式
     * @private
     * @returns void
     */
    private getStyle(el, attr) {
    return el.currentStyle
        ? el.currentStyle[attr]
        : getComputedStyle(el, null)[attr]
    }

    /**
     * 关闭提示
     * @private
     * @returns void
     */
    private onCloseTip(): void
    {
        this.showTipModel = false;
    }

    /**
     * 立即预约
     * @private
     * @returns void
     */
    private onSubscribe(): void
    {
        let data = {
            selectIds: this.selectIds,
            healthProductIds:this.healthProductIds,
            optionalItemIds: this.optionalItemIds
        }
        localStorage.setItem("selectOptionalItem", JSON.stringify(data));
        this.showDate = true;
        // this.$router.push({name: "submit-order", query:{packageId: this.packageId, date: this.selectDate,physicalTimePeriod: this.physicalTimePeriod, hospitalId: this.hospitalId}});
    }

    /**
     * 立即预约
     * @private
     * @returns void
     */
    private onGoSubscribe(): void
    {
        if (!this.selectDate) {
            Toast("请选择日期");
            return;
        }
        this.showDate = false;
        this.$router.push(
            {
                name: "submit-order",
                query:{
                    packageId: this.packageId,
                    date: this.selectDate,
                    physicalTimePeriod: this.physicalTimePeriod,
                    hospitalId: this.hospitalId,
                    productId: this.productId,
                }
            }
        );
    }

    /**
     * 先买后约
     * @private
     * @returns void
     */
    private onOnlyBuy(): void
    {
        this.showDate = false;
        this.$router.push(
            {
                name: "order-submit-unsubscribe",
                query:  {
                    packageId: this.packageId,
                    hospitalId: this.hospitalId,
                    productId: this.productId,
                }
            }
        );
    }

    /**
     * 立即预约
     * @private
     * @returns void
     */
    private itemChange(id, event,data): void
    {
        // 健康产品
        if(data.itemTypeKind == 3)
        {
            let index = this.healthProductIds.indexOf(id);
            if(index == -1)
            {
                this.healthProductIds.push(id);
            }else
            {
                this.healthProductIds.splice(index, 1);
            }
        }
        else
        {
            // 普通加项
            let index = this.optionalItemIds.indexOf(id);
            if(index == -1)
            {
                this.optionalItemIds.push(id);
            }else
            {
                this.optionalItemIds.splice(index, 1);
            }
        }
       
        if(this.selectIds.indexOf(id)> -1)
        {
            let index = this.selectIds.indexOf(id);
            this.selectIds.splice(index, 1);
        }
        else {
            this.addToCart(event);
            this.selectIds.push(id);
        }
    }

    /**
     * 自选项目变更时
     * @private
     * @returns void
     */
    private async onOptopnalItemChange(): Promise<void>
    {
        try
        {
            let data =
            {
                employerMemberId: this.selectUserId,
                basePrice: this.packageBasePrice,
                optionalPrice: this.optionalPrice
            }

            let {content: result} =  await PackageService.instance.getMedicalPackagePrice(data, false);
            this.assetConsumeInfo= result.data;
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件创建
     * @private
     * @returns void
     */
    private created(): void
    {   
        if(this.hospitalId)
        {
            this.filter.hospitalId = this.hospitalId;
        }
        this.selectDate = this.selectedDate || '';
        this.physicalTimePeriod = this.physicaledTimePeriod || '';
        this.filter.packageId = this.packageId;
        this.filter.employerMemberId = this.selectUserId;

        this.getOptionalPackageInfo(this.filter);
       
    }

    /**
     * 获取套餐详情
     * @private
     * @returns void
     */
    private async getOptionalPackageInfo(data: any): Promise<void>
    {
        try
        {
            let {content: result} =  await PackageService.instance.getOptionalPackageInfo(data);
            // let allItems = [...result.data.rightsItemTypesOut,...result.data.optionalItems];
            let allItems = [...result.data.optionalItems];
            allItems.forEach(item=>
            {
                this.titleList.push(item.itemTypeName);
                
            })
            this.$nextTick(()=>
            {
                this.listHeight();
            })
            this.dataList = allItems;
            if(result.data)
            {
                this.optionalItemTypesOut = result.data.optionalItems || [];
                this.packageBasePrice = result.data.packageBasePrice;
                this.packageInformation.packageName = result.data.packageName;
                this.packageInformation.packageMarketPrice = result.data.packageMarketPrice;
                this.onOptopnalItemChange();
                
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 显示提示
     * @private
     * @returns void
     */
    private showTip(remark: string, name: string): void
    {
        //         Dialog.alert({
        //             title: name,
        //             confirmButtonColor: "#00d5c1",
        //             messageAlign: "left",
        //             message: remark || `
        // 为保障员工健康，企业为员工提供了相应额度的报销福利，在额度内选购权益或加项的费用由企业承担${this.assetConsumeInfo.couponRate}%，剩余${100-this.assetConsumeInfo.couponRate}%由员工自费。(超出额度的部分由员工全自费)以额度为1000元为例，若员工选购了1000元的权益和加项，则企业支付${this.assetConsumeInfo.couponRate*1000/100}元，员工自费${1000-this.assetConsumeInfo.couponRate*1000/100}元。`,
        //             confirmButtonText: "确定"
        //         });

        this.dialogName = name
        this.dialogContent = remark || `
        为保障员工健康，企业为员工提供了相应额度的报销福利，在额度内选购权益或加项的费用由企业承担${this.assetConsumeInfo.couponRate}%，剩余${100-this.assetConsumeInfo.couponRate}%由员工自费。(超出额度的部分由员工全自费)以额度为1000元为例，若员工选购了1000元的权益和加项，则企业支付${this.assetConsumeInfo.couponRate*1000/100}元，员工自费${1000-this.assetConsumeInfo.couponRate*1000/100}元。`
        this.isShowDialog = true
    }

    /**
     * 判断两个数组是否有相同的数字
     * @private
     * @returns void
     */
    private isRepeat(arr1: Array<number>, arr2: Array<number>): boolean
    {
        for(let i=0;i<arr1.length;i++)
        {
            if(arr2.indexOf(arr1[i])>-1)
            {
                return true;
            }
        }
        return false;
       
    }
    
    /**
     * 更改标签选中状态
     * @private
     * @returns void
     */
    private onCheckTag(index: number, item: any, event: any): void
    {
        // Todo 健康产品和加项区分未实现
        let fileIndex = this.selectTagIds.indexOf(item.tagId);
        if(fileIndex == -1)
        {
            this.selectTagIds.push(item.tagId);
            this.addToCart(event);
        }
        else
        {
            this.selectTagIds.splice(fileIndex, 1);
        }
        this.selectIds = [];
        this.tagGroups.forEach(item=>
        {
            item.tags.forEach(data=>
            {
               
                if(this.selectTagIds.indexOf(data.tagId)> -1)
                {
                    this.selectIds.push(...data.itemIds);
                }
            })
        })
        
        this.selectIds = Array.from(new Set(this.selectIds));
        
    }
    
    /**
     * 获取企业参数配置
     * @private
     * @returns any
     */
    private get generalSettings(): any
    {
        let generalSettingsValue = localStorage.getItem("generalSettings");
        if(generalSettingsValue)
        {
            return JSON.parse(generalSettingsValue);
        }
        return [];
    }

    /**
     * 是否显示配置
     * @protected
     * @returns boolean
     */
    protected showStting(code: string): boolean
    {
        // A1001 -- 体检套餐列表页、详情页、提交订单页及订单详情页均不显示体检套餐价格及企业报销金额。
        // A1002 -- 体检套餐列表页、详情页均不显示体检套餐划线价格。
        // A2002 -- 开启后，体检套餐的自选加项页面底部将显示额度使用情况，但是额度为0时开启此开关后也不会显示额度使用进度。
        let data = this.generalSettings.filter(res => res.code == code);
        if (data.length > 0)
        {
            return data[0].isOpen;
        }
        else
        {
            return true;
        }
    }

}
